import { render, staticRenderFns } from "./TranslationsFilter.vue?vue&type=template&id=34470a60"
import script from "./TranslationsFilter.vue?vue&type=script&lang=js"
export * from "./TranslationsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports